import { Action } from '@ngrx/store';
import { IMemberProfilePhoneNumber } from '@shared/shared/interfaces/member-profile-phone-number.interfaces';

// Create phone number
export const CREATE_PROFILE_PHONE_NUMBER = '[Member Profile] Create Profile Phone Number';
export const CREATE_PROFILE_PHONE_NUMBER_SUCCESS = '[Member Profile] Create Profile Phone Number Success';
export const CREATE_PROFILE_PHONE_NUMBER_FAIL = '[Member Profile] Create Profile Phone Number Fail';

export class CreateProfilePhoneNumber implements Action {
  readonly type = CREATE_PROFILE_PHONE_NUMBER;
  constructor(public payload: IMemberProfilePhoneNumber) {}
}

export class CreateProfilePhoneNumberSuccess implements Action {
  readonly type = CREATE_PROFILE_PHONE_NUMBER_SUCCESS;
  constructor(public payload: IMemberProfilePhoneNumber) {}
}

export class CreateProfilePhoneNumberFail implements Action {
  readonly type = CREATE_PROFILE_PHONE_NUMBER_FAIL;
}

// Destroy phone number
export const DESTROY_PROFILE_PHONE_NUMBER = '[Member Profile] Destroy Profile Phone Number';
export const DESTROY_PROFILE_PHONE_NUMBER_SUCCESS = '[Member Profile] Destroy Profile Phone Number Success';
export const DESTROY_PROFILE_PHONE_NUMBER_FAIL = '[Member Profile] Destroy Profile Phone Number Fail';

export class DestroyProfilePhoneNumber implements Action {
  readonly type = DESTROY_PROFILE_PHONE_NUMBER;
  constructor(public payload: number) {}
}

export class DestroyProfilePhoneNumberSuccess implements Action {
  readonly type = DESTROY_PROFILE_PHONE_NUMBER_SUCCESS;
  constructor(public payload: number) {}
}

export class DestroyProfilePhoneNumberFail implements Action {
  readonly type = DESTROY_PROFILE_PHONE_NUMBER_FAIL;
}

// Update phone number
export const UPDATE_PROFILE_PHONE_NUMBER = '[Member Profile] Update Profile Phone Number';
export const UPDATE_PROFILE_PHONE_NUMBER_SUCCESS = '[Member Profile] Update Profile Phone Number Success';
export const UPDATE_PROFILE_PHONE_NUMBER_FAIL = '[Member Profile] Update Profile Phone Number Fail';

export class UpdateProfilePhoneNumber implements Action {
  readonly type = UPDATE_PROFILE_PHONE_NUMBER;
  constructor(public payload: any) {}
}

export class UpdateProfilePhoneNumberSuccess implements Action {
  readonly type = UPDATE_PROFILE_PHONE_NUMBER_SUCCESS;
  constructor(public payload: IMemberProfilePhoneNumber) {}
}

export class UpdateProfilePhoneNumberFail implements Action {
  readonly type = UPDATE_PROFILE_PHONE_NUMBER_FAIL;
}

export type MemberProfilePhoneNumberAction =
  | CreateProfilePhoneNumber
  | CreateProfilePhoneNumberSuccess
  | CreateProfilePhoneNumberFail
  | DestroyProfilePhoneNumber
  | DestroyProfilePhoneNumberSuccess
  | DestroyProfilePhoneNumberFail
  | UpdateProfilePhoneNumber
  | UpdateProfilePhoneNumberSuccess
  | UpdateProfilePhoneNumberFail;
